export default __webpack_public_path__ + "static/media/dentist-chair.9aa6f2dd.svg";